module.exports = __webpack_public_path__ + "static/leira-symbol-SCAG-095062f890cd57bede4aa4df5ac12a27.png";